import type { ReactElement } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth';

/**
 * Оборачивает группу маршрутов: пока идёт первый /me — показывает заглушку,
 * при отсутствии авторизации — редиректит на /login (с сохранением целевого
 * пути в state.from для пост-логин редиректа).
 */
export function ProtectedRoute(): ReactElement {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return (
            <div
                className="flex min-h-screen items-center justify-center text-gray-500"
                data-testid="auth-loading"
            >
                Загрузка...
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }

    return <Outlet />;
}
